import { render } from "./DeclinedLetter.vue?vue&type=template&id=635767d3"
import script from "./DeclinedLetter.vue?vue&type=script&lang=js"
export * from "./DeclinedLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__